// extracted by mini-css-extract-plugin
module.exports = {"card":"CTABanner_card__6J1I7","link":"CTABanner_link__Qb8bT","text":"CTABanner_text__xiS6N","button":"CTABanner_button__FaaEK"};